import { setFeatureDefinitions } from "motion-dom";
import { getInitializedFeatureDefinitions } from "./definitions";
export function loadFeatures(features) {
    const featureDefinitions = getInitializedFeatureDefinitions();
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
    setFeatureDefinitions(featureDefinitions);
}
//# sourceMappingURL=load-features.js.map